import { object, string, bool } from 'yup';
import i18next from 'i18next';

import { APARTMENT_VALIDATION, MAX_PLACES_ADDRESS_NOTE, MAX_CVC_LENGTH } from '~constants/validation';
import { ISO_COUNTRY } from '~constants/environment';

export const VALIDATIONS = {
  isRequired: bool(),
  mailCheckoutValidation: bool().required(),
  emailValidation: string()
    .email(i18next.t('Field:invalid', { field: i18next.t('Field:email') }))
    .required(i18next.t('Field:required', { field: i18next.t('Field:email') })),
  passwordValidation: string().required(i18next.t('Field:required', { field: i18next.t('Field:password') })),
  apartmentDetails: string()
    .max(
      APARTMENT_VALIDATION[ISO_COUNTRY]?.max || APARTMENT_VALIDATION.default.max,
      i18next.t('Field:max', {
        field: i18next.t('Field:apartment'),
        max: APARTMENT_VALIDATION[ISO_COUNTRY]?.max || APARTMENT_VALIDATION.default.max,
        interpolation: { escapeValue: false }
      })
    )
    .nullable(),
  placesAddress: string()
    .max(
      MAX_PLACES_ADDRESS_NOTE[ISO_COUNTRY]?.max || MAX_PLACES_ADDRESS_NOTE.default.max,
      i18next.t('Field:max', {
        field: i18next.t('Delivery:note'),
        max: MAX_PLACES_ADDRESS_NOTE[ISO_COUNTRY]?.max || MAX_PLACES_ADDRESS_NOTE.default.max,
        interpolation: { escapeValue: false }
      })
    )
    .nullable(),
  cvc: string()
    .required()
    .matches(/^[0-9]+$/, i18next.t('Field:onlyDigits'))
    .min(
      MAX_CVC_LENGTH,
      i18next.t('Field:max', {
        min: MAX_CVC_LENGTH
      })
    )
    .max(
      MAX_CVC_LENGTH,
      i18next.t('Field:max', {
        max: MAX_CVC_LENGTH
      })
    )
};

export const buildValidation = (validations) => object().shape(validations);
